module.exports = __webpack_public_path__ + "img/20190610161458281.decb0c0b.png";